import request from "@utils/request";
/*
 * 底部导航
 * */
export function getFootList() {
  return request.get("bottom", {}, { login: false });
}
/***
 * 防伪码查询
 */
export function AntiQuery(data) {
  return request.get("source/get_goods", data, { login: false });
}

/**
 * 获取溯源信息
 */
export function verifycode(data) {
  return request.post("source/verifycode", data, { login: false });
}

/**
 * 轮播图和按钮
 */
export function index(data) {
  return request.get("index", data, { login: false });
}

/**
 * 获取代理商
 */
export function get_agent() {
  return request.get("source/get_agent", {}, { login: false });
}

/**
 * 出库获取产品信息
 */

export function get_goods(data) {
  return request.get("source/get_goods", data, { login: false });
}

/**
 * 出库
 */
export function stock_goods(data) {
  return request.post("source/stock_goods", data, { login: false });
}
